/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use, useMemo } from 'fierry/react';


export default ({ Rpc, as: Context, children }) =>
{
  const rpc = use(Rpc);

  const state = use(Rpc(rpc => rpc.getSnapshot()));

  const application = useMemo(() => rpc.application.snapshot(), [ state ]);

  return <Context value = {application} children = {children} />;
};
